export function knowledgeHubPagination() {
    let $holderPosts = $('.posts-wrap');

    $holderPosts.on('click', '.pagination a', function (e) {
        e.preventDefault();

        let $holderCategoryPosts = $(this).closest('.ajax-holder-knowledge-hub');

        let data = {
            'action': 'pagination_knowledge_hub',
            'paged': $(this).attr('data-num')
        };

        $.ajax({
            url: ajaxvars.ajaxurl,
            data: data,
            type: 'POST',
            success: function (response) {
                $holderCategoryPosts.html(response);
            },
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/knowledgeHubPagination.js